export default __webpack_public_path__ + "static/media/flash-slash-purple.070c15f4.svg";